export default __webpack_public_path__ + "static/media/img (1).ef11cb1f.jpg";